/* eslint-disable no-underscore-dangle */
import "./payment-overlay.scss";

class PaymentOverlay {
  _$paymentOverlay;

  get $paymentOverlay() {
    this._$paymentOverlay ||= document.getElementById("payment-overlay");
    return this._$paymentOverlay;
  }

  constructor() {
    this.showState = false;
  }

  hide() {
    this.showState = false;
    this.$paymentOverlay?.classList?.remove("payment-overlay--show");
  }

  show() {
    this.showState = true;
    this.$paymentOverlay?.classList?.add("payment-overlay--show");
  }

  toggle() {
    if (this.showState) {
      this.hide();
    } else {
      this.show();
    }
  }
}

const paymentOverlay = new PaymentOverlay();
export default paymentOverlay;
